import useNetworkStatus from "../../hooks/useNetworkStatus";

// Invokes the useNetworkStatus hook to monitor network status changes.
// Intended for side effects only.
const NetworkStatusListener = () => {
  useNetworkStatus();
  return null;
};

export default NetworkStatusListener;